import React, { useState } from "react";
import Core from "./app/core/core";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./app/core/Home";
import Survey from "./app/core/Survey";
import UserContext from "./contexts/UserContext";
import CampaignContext from "./contexts/CampaignContext";
import CampaignDetailsContext from "./contexts/CampaignDetailsContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Provider } from "react-redux";
import mergeStore from "./redux/store";

const { store } = mergeStore();

const App = () => {
  const userHook = useState({});
  const companyHook = useState({});
  const campaignHook = useState({});

  // const { pathname } = useLocation();

  return (
    <Provider store={store}>
      <div className="box-border p-0 m-0 min-w-1440 leading-7">
        <UserContext.Provider value={userHook}>
          <CampaignContext.Provider value={companyHook}>
            <CampaignDetailsContext.Provider value={campaignHook}>
              <BrowserRouter>
                {window.location.pathname === "/survey" ? <Survey /> : <Home />}
                {/* <Home /> */}
                {/* // <Routes>
            //   <Route path="/survey" element={<Survey />} />
            // </Routes> */}
              </BrowserRouter>
              <ToastContainer />
            </CampaignDetailsContext.Provider>
          </CampaignContext.Provider>
        </UserContext.Provider>
      </div>
    </Provider>
  );
};

export default App;
